<template>
  <span v-tooltip:top="$props.text" class="tooltip-wrapper">
    <i class="zmdi zmdi-info f-14 c-indigo-500" />
  </span>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },
}
</script>
